import apiClient from '../../../services/api-client'
import type { BillingUsageItem } from '../types/billing.types'

interface BillingUsageListResponse {
  data: BillingUsageItem[]
}

export async function listBillingUsage(period: string): Promise<BillingUsageItem[]> {
  const response = await apiClient.get<BillingUsageListResponse>('/billing', {
    params: { period }
  })
  return response.data.data
}

export async function recalculateBillingDraft(period: string, tenantCode?: string): Promise<void> {
  await apiClient.post(`/billing/${period}/recalculate`, null, {
    params: tenantCode ? { tenantCode } : undefined
  })
}

export async function finaliseBilling(period: string, tenantCode?: string): Promise<void> {
  await apiClient.post(`/billing/${period}/finalise`, null, {
    params: tenantCode ? { tenantCode } : undefined
  })
}
